module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-27-a1fecd67f9427c47794ff4711a45341a.svg";